import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface UnsplashImage {
  id: string
  url: string
  description: string
  blurHash: string
  photographerProfile: string
  photographerName: string
}

interface GetUnsplashImagesResponse {
  query: string
  pictures: UnsplashImage[]
}

const getUnsplashImages = async (
  search: string,
  signal?: AbortSignal,
): Promise<GetUnsplashImagesResponse> => {
  const response = await authAPI.get<GetUnsplashImagesResponse>('/unsplash/search-pictures', {
    params: { query: search },
    signal,
  })

  return response.data
}

export const useGetUnsplashImages = (search: string) =>
  useQuery({
    enabled: !!search.trim(),
    queryFn: ({ signal }) => getUnsplashImages(search, signal),
    queryKey: ['unsplash', search],
  })
